import React from "react";
import PropTypes from "prop-types";

export default function AttributeToOpen(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const attribute = props.attribute;
  let caret = "fa fa-caret-up";
  if (isOpen) {
    caret = "fa fa-caret-up";
  } else {
    caret = "fa fa-caret-down";
  }

  return (
    <>
      <div
        className="attribute-to-open-container"
        style={props.fullWidth ? { width: "100%", padding: "0" } : {}}
      >
        <div
          className="RestaurantInfo-crew"
          style={
            attribute.description
              ? { cursor: "pointer", width: "initial" }
              : { width: "initial" }
          }
          onClick={e => {
            if (attribute.description) {
              setIsOpen(!isOpen);
            }
            e.preventDefault();
          }}
        >
          <i
            className={`icon icon-${attribute._id.icon} attribute-to-open-icon`}
            style={{ lineHeight: "18px" }}
          />
          {attribute._id[`label_it`]}
          <span style={{ float: "right" }}>
            {attribute.description ? (
              <i style={{ marginRight: "10px" }} className={caret} />
            ) : null}
          </span>
        </div>
        {isOpen ? (
          <div className="RestaurantInfo-crew attribute-to-open-description">
            {attribute.description}
          </div>
        ) : null}
      </div>
    </>
  );
}

AttributeToOpen.propTypes = {
  attribute: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool
};

AttributeToOpen.defaultProps = {
  fullWidth: false
};
